import React from 'react';
import { formatDate, formatTime } from './common/timestampFormat';
import { toTitleCase } from '../util/titleCase';

const CategorizedNotes = ({ currentNotes, olderNotes }) => {
    const NoteCard = ({ note }) => (
        <div className=''>
            <div className="inset-0 z-1 rounded-l-md rounded-r-none border border-blue-200 mt-2 mb-4 bg-blue-800 relative newHomework mr-4">
                <div className="bg-white newHomework p-4 text-gray-100 -mt-3 -ml-3 inset-0 absolute newNotesShadow mr-4">
                    <div className="block mx-auto text-center newHomeworkPositioning">
                        <div className="flex justify-center mx-auto font-semibold text-gray-100 text-base">
                            {toTitleCase(note.subjectname)}
                        </div>
                        <div className="flex justify-center mx-auto font-semibold text-xs text-gray-300 mb-4">
                            {note.subtopic}
                        </div>
                        <div className="flex flex-col justify-center newHomeworkDate text-xs text-gray-500 px-2 leading-3 mb-4">
                            <span className="flex justify-center"> {formatDate(note.timestp)} </span>
                            <span className="flex justify-center mt-1"> {formatTime(note.timestp)} </span>
                        </div>
                        <div className="flex justify-center items-center cursor-pointer p-2 mb-2 text-xs font-medium rounded border border-gray-500 newHomeworkView">
                            <a href={note.downloadURL} target='_blank' rel='noopener noreferrer' className="mr-2"> Download </a>
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M1.33317 11.6667H10.6665C10.8433 11.6667 11.0129 11.7369 11.1379 11.862C11.2629 11.987 11.3332 12.1566 11.3332 12.3334C11.3332 12.5102 11.2629 12.6798 11.1379 12.8048C11.0129 12.9298 10.8433 13 10.6665 13H1.33317C1.15636 13 0.98679 12.9298 0.861766 12.8048C0.736742 12.6798 0.666504 12.5102 0.666504 12.3334C0.666504 12.1566 0.736742 11.987 0.861766 11.862C0.98679 11.7369 1.15636 11.6667 1.33317 11.6667ZM6.6665 7.78338L8.8285 5.62204L9.77117 6.56471L5.99984 10.336L2.2285 6.56471L3.17117 5.62204L5.33317 7.78338V0.333374H6.6665V7.78338Z" fill="#000114"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            {/* Current Notes Section */}
            {currentNotes && currentNotes.length > 0 && (
                <div className="mb-8">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 col-gap-8 justify-center ml-12 sm:ml-0 px-3 sm:px-2">
                        {currentNotes.map((note, index) => (
                            <NoteCard key={`current-${index}`} note={note} />
                        ))}
                    </div>
                </div>
            )}

            {/* Older Notes Section */}
            {olderNotes && olderNotes.length > 0 && (
                <div className="mb-8">
                    <div className="mb-6 px-3 sm:px-2 ml-12 sm:ml-0">
                        <h2 className="text-xl font-semibold text-gray-700 border-b-2 border-gray-300 pb-2">
                            Older Notes
                        </h2>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 col-gap-8 justify-center ml-12 sm:ml-0 px-3 sm:px-2">
                        {olderNotes.map((note, index) => (
                            <NoteCard key={`older-${index}`} note={note} />
                        ))}
                    </div>
                </div>
            )}

            {/* No Notes Message */}
            {(!currentNotes || currentNotes.length === 0) && (!olderNotes || olderNotes.length === 0) && (
                <div className='flex justify-center w-full sm:mt-16'>
                    <div className="text-center text-gray-500">
                        <p className="text-lg font-medium">No notes available</p>
                        <p className="text-sm">Notes uploaded by teachers would be displayed here</p>
                    </div>
                </div>
            )}
        </>
    );
};

export default CategorizedNotes;